import React from "react";
import { CommentQuestion } from "anketa-core/command_question";
import { EuiComment, EuiMarkdownFormat } from "@elastic/eui";
import { useAnketa } from "../../context_provider";
import { Translation } from "anketa-core/i18n";
import { useAnketaI18n } from "src/internationalization";
import { renderTime } from "../../../../";

export const CommentQuestionList = ({ props }: { props: CommentQuestion }) => {
  const ctx = useAnketa();
  const { commentType, createTime, user: commentUser } = props.commentValues;
  const { currentLang } = useAnketaI18n();

  return (
    <EuiComment
      username={commentUser}
      event={ctx.i18nContext.render([
        new Translation("en", "added a comment"),
        new Translation("de", "added a comment"),
      ])}
      //actions={copyAction}
      timestamp={renderTime(createTime, currentLang)}
      timelineIcon={
        commentType === "question" ? "questionInCircle" : "chatLeft"
      }
    >
      <EuiMarkdownFormat>
        {ctx.i18nContext.render(
          props.fact.raw ? props.fact.raw.toString() : ""
        )}
      </EuiMarkdownFormat>
    </EuiComment>
  );
};
